import type { Fetcher } from 'swr';

import axiosWithAuth from '@/lib/axios';
import type Announcement from '@/types/database/announcement';

import type { AnnouncementListFetcherParams } from './types';

export const fetchAnnouncementList: Fetcher<{
  data: Announcement[];
  total: number;
}> = async (params: AnnouncementListFetcherParams) => {
  const { data } = await axiosWithAuth({
    method: 'GET',
    url: '/ezcon/api/announcements',
    params,
  });

  return data;
};
